import { HttpUrlEncodingCodec } from '@angular/common/http';

export class BHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  encodeKey(k: string): string {
    return super.encodeKey(k);
  }

  encodeValue(v: string): string {
    return super.encodeValue(v).replace(/\+/gi, '%2B');
  }

  decodeKey(k: string): string {
    return super.decodeKey(k);
  }

  decodeValue(v: string) {
    return super.decodeValue(v);
  }
}
